
import ReplaceMajorsWithMinorsSwitch from './ReplaceMajorsWithMinorsSwitch';

export default ReplaceMajorsWithMinorsSwitch;
